// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `body {
    margin: 0; /* Remove default body margin */
}

.BannerMid_heroContainer__9GWU8 {
    position: relative;
    width: 100%;
    height: 60vh; /* Adjustable height */
    overflow: hidden;
}

/* Ensures the image covers the full screen width */
.BannerMid_heroImage__CXsKp {
    width: 100%;
    height: 100%;
    object-fit: cover;
}

.BannerMid_heroOverlay__JhiPO {
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    background: linear-gradient(to bottom, rgb(0 0 0 / 92%) 0%, rgb(0 0 0 / 53%) 50%);
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    gap: 20px;
}

.BannerMid_heroTitle__o\\+8CA {
    color: white;
    font-size: 2.5rem;
    font-weight: bold;
    text-align: center;
    margin: 0;
    padding: 0 20px;
}

.BannerMid_exploreButton__Irhl2 {
    padding: 12px 24px;
    font-size: 1rem;
    color: white;
    background: transparent;
    border: 2px solid white;
    cursor: pointer;
    position: relative;
    overflow: hidden;
    transition: all 0.3s ease;
    text-transform: none;
    font-weight: 600;
}

.BannerMid_exploreButton__Irhl2:hover {
    background: rgba(255, 255, 255, 0.1);
}

.BannerMid_exploreButton__Irhl2::before {
    content: '';
    position: absolute;
    top: 0;
    left: -100%;
    width: 100%;
    height: 100%;
    background: linear-gradient(
        120deg,
        transparent,
        rgba(255, 255, 255, 0.2),
        transparent
    );
    transition: 0.5s;
}

.BannerMid_exploreButton__Irhl2:hover::before {
    left: 100%;
}

@media (max-width: 820px) {
    .BannerMid_heroTitle__o\\+8CA {
        font-size: 2rem;
    }
    
    .BannerMid_exploreButton__Irhl2 {
        padding: 10px 20px;
        font-size: 0.9rem;
    }
    .BannerMid_heroContainer__9GWU8 {
        height: 45vh; /* Adjustable height */
    }
}
@media (max-width: 488px) {
    .BannerMid_heroTitle__o\\+8CA {
        font-size: 1.7rem;
    }
    .BannerMid_heroContainer__9GWU8 {
        height: 50vh; /* Adjustable height */
    }
    .BannerMid_heroOverlay__JhiPO {
        padding: 1rem 0rem 0rem 1rem;
    }
    
}
`, "",{"version":3,"sources":["webpack://./src/Blogs/Components/CSS/BannerMid.module.css"],"names":[],"mappings":"AAAA;IACI,SAAS,EAAE,+BAA+B;AAC9C;;AAEA;IACI,kBAAkB;IAClB,WAAW;IACX,YAAY,EAAE,sBAAsB;IACpC,gBAAgB;AACpB;;AAEA,mDAAmD;AACnD;IACI,WAAW;IACX,YAAY;IACZ,iBAAiB;AACrB;;AAEA;IACI,kBAAkB;IAClB,MAAM;IACN,OAAO;IACP,WAAW;IACX,YAAY;IACZ,iFAAiF;IACjF,aAAa;IACb,sBAAsB;IACtB,uBAAuB;IACvB,mBAAmB;IACnB,SAAS;AACb;;AAEA;IACI,YAAY;IACZ,iBAAiB;IACjB,iBAAiB;IACjB,kBAAkB;IAClB,SAAS;IACT,eAAe;AACnB;;AAEA;IACI,kBAAkB;IAClB,eAAe;IACf,YAAY;IACZ,uBAAuB;IACvB,uBAAuB;IACvB,eAAe;IACf,kBAAkB;IAClB,gBAAgB;IAChB,yBAAyB;IACzB,oBAAoB;IACpB,gBAAgB;AACpB;;AAEA;IACI,oCAAoC;AACxC;;AAEA;IACI,WAAW;IACX,kBAAkB;IAClB,MAAM;IACN,WAAW;IACX,WAAW;IACX,YAAY;IACZ;;;;;KAKC;IACD,gBAAgB;AACpB;;AAEA;IACI,UAAU;AACd;;AAEA;IACI;QACI,eAAe;IACnB;;IAEA;QACI,kBAAkB;QAClB,iBAAiB;IACrB;IACA;QACI,YAAY,EAAE,sBAAsB;IACxC;AACJ;AACA;IACI;QACI,iBAAiB;IACrB;IACA;QACI,YAAY,EAAE,sBAAsB;IACxC;IACA;QACI,4BAA4B;IAChC;;AAEJ","sourcesContent":["body {\n    margin: 0; /* Remove default body margin */\n}\n\n.heroContainer {\n    position: relative;\n    width: 100%;\n    height: 60vh; /* Adjustable height */\n    overflow: hidden;\n}\n\n/* Ensures the image covers the full screen width */\n.heroImage {\n    width: 100%;\n    height: 100%;\n    object-fit: cover;\n}\n\n.heroOverlay {\n    position: absolute;\n    top: 0;\n    left: 0;\n    width: 100%;\n    height: 100%;\n    background: linear-gradient(to bottom, rgb(0 0 0 / 92%) 0%, rgb(0 0 0 / 53%) 50%);\n    display: flex;\n    flex-direction: column;\n    justify-content: center;\n    align-items: center;\n    gap: 20px;\n}\n\n.heroTitle {\n    color: white;\n    font-size: 2.5rem;\n    font-weight: bold;\n    text-align: center;\n    margin: 0;\n    padding: 0 20px;\n}\n\n.exploreButton {\n    padding: 12px 24px;\n    font-size: 1rem;\n    color: white;\n    background: transparent;\n    border: 2px solid white;\n    cursor: pointer;\n    position: relative;\n    overflow: hidden;\n    transition: all 0.3s ease;\n    text-transform: none;\n    font-weight: 600;\n}\n\n.exploreButton:hover {\n    background: rgba(255, 255, 255, 0.1);\n}\n\n.exploreButton::before {\n    content: '';\n    position: absolute;\n    top: 0;\n    left: -100%;\n    width: 100%;\n    height: 100%;\n    background: linear-gradient(\n        120deg,\n        transparent,\n        rgba(255, 255, 255, 0.2),\n        transparent\n    );\n    transition: 0.5s;\n}\n\n.exploreButton:hover::before {\n    left: 100%;\n}\n\n@media (max-width: 820px) {\n    .heroTitle {\n        font-size: 2rem;\n    }\n    \n    .exploreButton {\n        padding: 10px 20px;\n        font-size: 0.9rem;\n    }\n    .heroContainer {\n        height: 45vh; /* Adjustable height */\n    }\n}\n@media (max-width: 488px) {\n    .heroTitle {\n        font-size: 1.7rem;\n    }\n    .heroContainer {\n        height: 50vh; /* Adjustable height */\n    }\n    .heroOverlay {\n        padding: 1rem 0rem 0rem 1rem;\n    }\n    \n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"heroContainer": `BannerMid_heroContainer__9GWU8`,
	"heroImage": `BannerMid_heroImage__CXsKp`,
	"heroOverlay": `BannerMid_heroOverlay__JhiPO`,
	"heroTitle": `BannerMid_heroTitle__o+8CA`,
	"exploreButton": `BannerMid_exploreButton__Irhl2`
};
export default ___CSS_LOADER_EXPORT___;
